import { useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const fmt = (n) => (n == null ? '—' : `$${Number(n).toLocaleString('es-CO')}`);
export const REASONS = {
  not_active: 'No está activa', no_coverage: 'Destino sin cobertura', shipping_already_free: 'El envío ya es gratis',
  not_started: 'Aún no inicia', ended: 'Finalizó', zone_excluded: 'Zona no incluida', seller_excluded: 'Vendedor no participa',
  below_min_subtotal: 'No alcanza el monto mínimo', seller_not_accepted: 'El vendedor no la ha aceptado',
  buyer_limit_reached: 'Comprador alcanzó el límite de usos', limit_exhausted: 'Presupuesto o tope agotado',
  below_min_discount: 'Descuento menor al mínimo',
};

export const PromoSimulator = () => {
  const [f, setF] = useState({ seller_id: '', buyer_id: '', department: '', city: '', price: '', qty: '1', commission_amount: '', base_shipping: '', at: '' });
  const [r, setR] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const run = async () => {
    try {
      const { data } = await api.post('/admin/shipping-promotions/simulate', {
        seller_id: f.seller_id || null, buyer_id: f.buyer_id || null, department: f.department || null, city: f.city || null,
        lines: [{ price: Number(f.price || 0), qty: Number(f.qty || 1) }],
        commission_amount: f.commission_amount === '' ? null : Number(f.commission_amount),
        base_shipping: f.base_shipping === '' ? null : Number(f.base_shipping), at: f.at || null, include_drafts: true,
      });
      setR(data);
    } catch (e) { toast.error(e.response?.data?.detail?.message || e.response?.data?.detail || 'No se pudo simular'); }
  };

  const a = r?.applied;
  return (
    <div data-testid="promo-simulator">
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        {[['seller_id', 'ID vendedor'], ['buyer_id', 'ID comprador (opcional)'], ['department', 'Departamento'], ['city', 'Ciudad'],
          ['price', 'Subtotal productos (COP)'], ['qty', 'Cantidad'], ['commission_amount', 'Comisión AutoMarket (COP)'], ['base_shipping', 'Envío base sin vendedor (COP)']].map(([k, l]) => (
          <Input key={k} placeholder={l} value={f[k]} onChange={set(k)} className="h-9 rounded-none text-sm" data-testid={`promo-sim-${k}`} />
        ))}
        <Input type="datetime-local" value={f.at} onChange={set('at')} className="h-9 rounded-none text-sm" data-testid="promo-sim-at" />
      </div>
      <Button size="sm" className="mt-2 rounded-none bg-slate-900" onClick={run} data-testid="promo-sim-run">Simular (incluye borradores)</Button>
      {r && (
        <div className="mt-3 border border-slate-200 bg-slate-50 p-3 text-sm" data-testid="promo-sim-result">
          {!r.quote.covered ? <p className="text-rose-700" data-testid="promo-sim-uncovered">Destino sin cobertura: no hay compra ni promoción.</p> : (
            <>
              <p>Envío actual: <b data-testid="promo-sim-base">{fmt(r.quote.amount)}</b></p>
              {a ? (
                <ul className="mt-1 space-y-0.5" data-testid="promo-sim-applied">
                  <li>Promoción: <b>{a.name}</b></li>
                  <li>Descuento: <b data-testid="promo-sim-discount">{fmt(a.discount)}</b> · comprador pagaría <b data-testid="promo-sim-buyer">{fmt(a.buyer_charge)}</b></li>
                  <li>AutoMarket asume <b data-testid="promo-sim-am">{fmt(a.subsidy_automarket)}</b> · vendedor asume <b data-testid="promo-sim-seller">{fmt(a.subsidy_seller)}</b></li>
                  {a.limits_hit.length > 0 && <li className="text-amber-700">Límites aplicados: {a.limits_hit.join(', ')}</li>}
                </ul>
              ) : <p className="mt-1 text-slate-600" data-testid="promo-sim-none">Ninguna promoción aplicaría.</p>}
            </>
          )}
          <ul className="mt-2 text-xs text-slate-500">
            {r.evaluations.filter((e) => !e.applies).map((e) => <li key={e.promo_id}>{e.name}: {REASONS[e.reason] || e.reason}</li>)}
          </ul>
          <p className="mt-2 text-xs text-amber-700">{r.note}</p>
        </div>
      )}
    </div>
  );
};
